import { useEffect } from 'react';
import { CONSTANTS } from './constants';
import { isDevelopmentSite } from './utils';

export default function StoreReferrer() {

    useEffect(() => {
        redirectWithParams();
    }, []);

    const checkIfShopPublic = (shop_id, url, searchParam) => {
        let apiUrl = isDevelopmentSite() ? "http://localhost:8000" : CONSTANTS.PRODUCTS.SOLO.API_URL;
        if(shop_id){
            fetch(`${apiUrl}/shop/isShopPublic?shop_id=${shop_id}`)
                .then(response => response.json())
                .then(data => {
                    if(data.data) {
                        triggerRedirectionToShop(shop_id);
                    } else {
                        triggerRedirection(url, searchParam);
                    }
                });
        } else {
            triggerRedirection(url, searchParam);
        }
    }

    const redirectWithParams = () => {
        const url = getPlatformStoreUrl();
        const { searchParam, id, referrer, target } = getParams();
        if(target?.toLowerCase() === 'app-download') {
            triggerRedirection(url, searchParam);
        } else {
            if(CONSTANTS.PRODUCTS.SOLO.PACKAGE_NAME === id) {
                const { shop_id } = decodeShopDetails(referrer);
                checkIfShopPublic(shop_id, url, searchParam);
            } else {
                triggerRedirection(url, searchParam);
            }
        }
    }

    const triggerRedirection = (url, searchParam) => {
        if(url) {
            window.location.href = url + searchParam;
        }
    }

    const triggerRedirectionToShop = (shop_id) => {
        if(shop_id) {
            window.location.href = `${CONSTANTS.PRODUCTS.SOLO.WEB_URL}/shop/${btoa(shop_id)}`;
        }
    }

    const getPlatformStoreUrl = () => { 
        const isApple = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
        return isApple ? CONSTANTS.APP_STORE_URL : CONSTANTS.PLAY_STORE_URL;
    }

    const getParams = () => {
        if(window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            const referrer = urlParams.get('referrer');
            const target = urlParams.get('target');
            const id = urlParams.get('id');
            let params = '';
            if(id) {
                params += `id=${id}`;
            }
            if(referrer) {
                params += `&referrer=${referrer}`;
            }
            return { 
                searchParam: params ? '?' + params : '', 
                referrer,
                target,
                id
            };
        }

        return { searchParam: '', id: '', referrer: '', target: '' };
    }

    const decodeShopDetails = (referrer) => {
        try {
            const decoded = atob(referrer);
            const [mobileNumber, shop_id_encoded] = decoded.split('_');
            const shop_id = shop_id_encoded ? atob(shop_id_encoded) : null;
            return { shop_id, mobileNumber };
        } catch (error) {
            console.log(error);
            return { shop_id: null, mobileNumber: null };
        };
    }

    return null;
}